<template>
  <v-snackbar :timeout="4000" :top="false" :bottom="true" :right="true" :left="false" v-model="showMessage">
    {{ config.message }}
    <v-btn dark flat @click.native="remove">Close</v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapGetters('notification', ['config']),
    showMessage: {
      get: function () {
        return this.config.show
      },
      set: function () {
        this.notify({message: '', show: false})
      }
    }
  },
  methods: {
    ...mapMutations('notification', ['remove', 'notify'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Notifier.vue